// hooks/features/calls/useCallNotifications.ts
import { useNavigate } from 'react-router-dom';
import useNotifications from '../../core/useNotifications';

export default function useCallNotifications() {
  // ✅ Je récupère showNotification du hook générique
  const { showNotification, closeNotifications, permission, isServiceWorkerReady } = useNotifications();
  const navigate = useNavigate();

  const showIncomingCall = (clientName: string, clientPhone: string, data: any = {}) => {
    // ✅ J'utilise showNotification correctement
    return showNotification({
      title: '📞 Appel entrant',
      body: `${clientName}${clientPhone ? ` (${clientPhone})` : ''} vous appelle`,
      data: {
        clientName,
        clientPhone,
        ...data
      },
      onClick: (payload) => {
        navigate('/agent/calls');
        window.dispatchEvent(new CustomEvent('answerCall', { detail: payload }));
      }
    });
  };

  const showCallEnded = (clientName?: string) => {
    // ✅ J'utilise showNotification correctement
    return showNotification({
      title: '📞 Appel terminé',
      body: clientName ? `Appel avec ${clientName} terminé` : 'Appel terminé',
      data: { type: 'call_ended' }
    });
  };

  return {
    // ✅ J'exporte showNotification pour que votre code existant continue de fonctionner
    showNotification,  // <-- ICI
    showIncomingCall,
    showCallEnded,
    closeNotifications,
    permission,
    isServiceWorkerReady
  };
}